export enum ToastMessageSeverity {
    Success = 'success',
    Warning = 'warn',
    Information = 'info',
    Error = 'error'
}